import React from "react";
import { Link, Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <>
      <header className="site-header">
        <nav className="navbar navbar-expand-lg">
          <div className="container site-nav">
            <Link className="brand-lockup" to="/">
              <img src="/images/logo-official.svg" alt="Zagol Seniors Care logo" className="brand-logo" />
            </Link>

            <div className="nav-links">
              <Link className="nav-link-custom" to="/">
                Home
              </Link>
              <Link className="nav-link-custom" to="/services">
                Services
              </Link>
              <a
                className="nav-link-custom"
                href="https://www.aplaceformom.com/community/zagol-seniors-care-1460679"
                target="_blank"
                rel="noreferrer"
              >
                Testimonials
              </a>
              <a className="btn btn-brand nav-phone" href="tel:2064077484">
                206-407-7484
              </a>
            </div>
          </div>
        </nav>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="container footer-content">
          <div>
            <strong>Zagol Seniors Care</strong>
            <p>Thoughtful senior care in a warm adult family home setting.</p>
          </div>
          <div>
            <span>714 88th St SE, Everett, WA 98012</span>
            <a href="tel:2064077484">206-407-7484</a>
          </div>
        </div>
      </footer>
    </>
  );
}
